import React, { useEffect, useState } from 'react'
import {
    FibaInput, FibaTab, FibaTabStrip,
    FibaTextArea, Form
} from '../../components';
import { Field } from '@progress/kendo-react-form';
import { ColorPicker } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';
import ColorPhoto from './ColorPhoto';
import ColorSize from './ColorSize';

const ColorDetail = ({ show, productid, onClose }) => {
    const { t } = useTranslation()

    return (
        <div>
            <FibaTab tabPosition={'right'}>
                <FibaTabStrip title={'Дэлгэрэнгүй мэдээлэл'}>
                    <Form
                        initialValues={show.data}
                        detail={'ml000019'}
                        create={'ml000017'}
                        update={'ml000018'}
                        id={show.data.id}
                        userSendData={{ productid }}
                        afterRedirect={false}
                        onFinish={onClose}
                    >
                        <div className='grid gap-4 md:grid-cols-2 sm:grid-cols-1'>
                            <div>
                                <label htmlFor={'color'} className="block text-sm font-medium text-gray-700">
                                    {t('color')}
                                    <span className='k-required'>*</span>
                                </label>
                                <Field
                                    name={'color'}
                                    view={'gradient'}
                                    component={ColorPicker}
                                />
                            </div>
                            <Field
                                name={'name'}
                                component={FibaInput}
                                label={"Өнгөний нэршил"}
                                required={true}
                            />
                            <Field
                                name={'name2'}
                                component={FibaInput}
                                label={"Өнгөний нэршил /ENG/"}
                                required={true}
                            />
                            <div className='col-span-full'>
                                <Field
                                    name={'description'}
                                    component={FibaTextArea}
                                    label={"Дэлгэрэнгүй мэдээлэл"}
                                    required={true}
                                />
                            </div>

                        </div>

                    </Form>
                </FibaTabStrip>
                <FibaTabStrip title={"Зураг"} disabled={show.data.id ? false : true}>
                    <ColorPhoto colorid={show.data.id} productid={productid} />
                </FibaTabStrip>
                <FibaTabStrip title={"Хэмжээ"} disabled={show.data.id ? false : true}>
                    <ColorSize colorid={show.data.id} productid={productid}/>
                </FibaTabStrip>
            </FibaTab>
        </div>
    )
}

export default ColorDetail